const Map = () => {
    return (<>
     <div className="map">
        <h2>Informasi <span className="orange_text">Banjir Sekitarmu</span></h2>
        <p>Cek lokasi disekitarmu apakah terbebas dari banjir</p>
        <img src="/map.png" alt="icon"/>
     </div>
    </>)
}

export default Map